import { Checkbox as MaterialCheckbox } from '@material-ui/core';
import { CheckboxNonSelected, CheckboxSelected } from '@images/icons';
import { ChangeEvent } from 'react';
import { CheckboxClassKey, ClassNameMap } from '@mui/material';

interface CheckboxProps {
  id?: string;
  className?: string;
  checked?: boolean;
  disabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  icon?: JSX.Element;
  checkedIcon?: JSX.Element;
  checkedIconDisabled?: JSX.Element;
  iconDisabled?: JSX.Element;
  dataTestId?: string;
  classes?: Partial<ClassNameMap<CheckboxClassKey>>;
}

export const Checkbox = ({
  id,
  checked,
  disabled,
  onChange,
  icon = <CheckboxNonSelected />,
  checkedIcon = <CheckboxSelected />,
  checkedIconDisabled = <CheckboxSelected />,
  iconDisabled = <CheckboxNonSelected />,
  dataTestId = 'sc-checkbox-container',
  classes,
}: CheckboxProps) => {
  return (
    <MaterialCheckbox
      data-testid={dataTestId}
      id={id}
      icon={disabled ? iconDisabled : icon}
      checkedIcon={disabled ? checkedIconDisabled : checkedIcon}
      disabled={disabled}
      checked={checked}
      onChange={onChange}
      classes={classes}
    />
  );
};
